export const logoutFunction = (status) => {
    if (status === 403) {
        window.location.pathname = "/usernotfound";
    }
    if (status === 401) {
        window.location.pathname = "/sessionexpired";
    }
}
